import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {TransitionComponent} from './transition/transition.component';

const routes: Routes = [
  { path: '**', component: TransitionComponent }];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
